import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { adsService } from '../services/ads.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';
import type { CreateCampaignData } from '../types/ads.types';

interface CreateCampaignParams {
  data: CreateCampaignData;
  bannerImage?: File;
}

export function useCreateCampaign() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateCampaignData | CreateCampaignParams) => {
      // Support both old signature (just data) and new signature (data + bannerImage)
      if ('data' in params && 'bannerImage' in params) {
        return adsService.createCampaign(params.data, params.bannerImage);
      }
      // Backwards compatible: just data passed directly
      return adsService.createCampaign(params as CreateCampaignData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['adWallet'] });
      toast.success('Campagne créée avec succès');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}
